import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import { UsersOrderBy, Role } from '@/interfaces/user';
import { showErrors, showNotification } from '@/utils/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppCheckbox from '@/components/AppCheckbox.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import ListPage from '@/mixins/list-page';
import ManagerDialog from './script-dialog';
import { exportManagersList, findManagers } from './gql';
import { SnackType } from '@/interfaces/snack';
import { downloadBase64 } from '@/helpers/base64-to-file';

var ManagerList = /*#__PURE__*/function (_mixins) {
  _inherits(ManagerList, _mixins);

  var _super = _createSuper(ManagerList);

  function ManagerList() {
    var _this;

    _classCallCheck(this, ManagerList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '系统管理'
    }, {
      text: '管理员列表'
    }];
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.filter = {
      username: ''
    };
    _this.totalNum = 0;
    _this.usersLoading = true;
    _this.headers = [{
      text: '管理员姓名',
      value: 'username'
    }, {
      text: '电话',
      value: 'phone'
    }, {
      text: '管理员类别',
      value: 'role',
      sortable: false
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.users = [];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    return _this;
  }

  _createClass(ManagerList, [{
    key: "mounted",
    value: function mounted() {
      this.onResize();
      this.restorePage(this.cache);
    }
  }, {
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getManagers();
    }
  }, {
    key: "canAction",
    value: function canAction(userId) {
      var me = this.me;
      return me.role === Role.ROOT || me.id === userId;
    }
  }, {
    key: "refreshList",
    value: function () {
      var _refreshList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.filter = {
                  username: ''
                };
                this.getManagers();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshList() {
        return _refreshList.apply(this, arguments);
      }

      return refreshList;
    }()
  }, {
    key: "getManagers",
    value: function () {
      var _getManagers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, username, orderBy, asc, result, typedError;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                username = this.filter.username;
                orderBy = UsersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0];
                this.usersLoading = true;
                _context2.prev = 5;
                _context2.next = 8;
                return this.$apollo.query({
                  query: findManagers,
                  variables: {
                    order: [{
                      by: orderBy,
                      asc: asc
                    }],
                    where: {
                      username: username || null
                    },
                    paging: {
                      skip: itemsPerPage * (page - 1),
                      take: itemsPerPage * page
                    }
                  }
                });

              case 8:
                result = _context2.sent;

                if (result.data) {
                  _context2.next = 12;
                  break;
                }

                showErrors(result.errors);
                return _context2.abrupt("return");

              case 12:
                this.users = result.data.findManagers.users;
                this.usersLoading = false;
                this.totalNum = result.data.findManagers.paging.totalCount;
                this.storePage();
                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 18]]);
      }));

      function getManagers() {
        return _getManagers.apply(this, arguments);
      }

      return getManagers;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function () {
      var _filterQuerySubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getManagers();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function filterQuerySubmit() {
        return _filterQuerySubmit.apply(this, arguments);
      }

      return filterQuerySubmit;
    }()
  }, {
    key: "userFormConfirm",
    value: function () {
      var _userFormConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var type;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                type = this.managerInput.type;

                if (!(type === 'new')) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 4;
                return this.newManagerConfirm();

              case 4:
                _context4.next = 6;
                return this.getManagers();

              case 6:
                _context4.next = 12;
                break;

              case 8:
                _context4.next = 10;
                return this.editManagerConfirm();

              case 10:
                _context4.next = 12;
                return this.getManagers();

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function userFormConfirm() {
        return _userFormConfirm.apply(this, arguments);
      }

      return userFormConfirm;
    }()
  }, {
    key: "deleteDialogConfirm",
    value: function () {
      var _deleteDialogConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.deleteManagerConfirm();

              case 2:
                this.getManagers();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteDialogConfirm() {
        return _deleteDialogConfirm.apply(this, arguments);
      }

      return deleteDialogConfirm;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this$options2, sortBy, sortDesc, username, by, asc, order, where, result, _result$data$exportMa, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                username = this.filter.username;
                by = UsersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.usersLoading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  username: username || null
                };
                _context6.prev = 8;
                _context6.next = 11;
                return this.$apollo.query({
                  query: exportManagersList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context6.sent;

                if (result.data) {
                  _result$data$exportMa = result.data.exportManagersList, fileName = _result$data$exportMa.fileName, contentB64 = _result$data$exportMa.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.usersLoading = false;
                _context6.next = 20;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](8);
                typedError = _context6.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }]);

  return ManagerList;
}(mixins(ManagerDialog, ListPage));

__decorate([State(function (state) {
  return state.page.UserList;
})], ManagerList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], ManagerList.prototype, "onOptionsChanged", null);

ManagerList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppCheckbox: AppCheckbox,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSearchBtn: AppSearchBtn,
    AppTextField: AppTextField
  }
})], ManagerList);
export default ManagerList;